export default {
  props: ['featureKey', 'isSelected'],
  methods: {
    onClick() {
      this.$emit('onClick', this.featureKey)
    }
  }
}
